const doc = [({"da":({"js":({"admin":({"activity_participant_type_rules":({"table":({"number_of_students_assigned_to_participant_type":"Antal studerende tildelt deltagertypen"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;